import React from 'react';
import { mockData } from '../mock/mockData';

const Footer = () => {
  const { footer } = mockData;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-logo">
          <span className="footer-logo-text">$KIM</span>
        </div>

        <div className="footer-disclaimer">
          <p>{footer.disclaimer}</p>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">{footer.copyright}</p>
          <button onClick={scrollToTop} className="footer-back-to-top">
            Back to Top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
